import certificate2 from '../../image/certificate2.png';
import certificate1 from '../../image/certificate1.png';
import "./certificate.css";
export default function Certificate() {
  return (
    <div className='certificate'>
      <h3 className='titels'>Certificate </h3>
    <div className='container_certificate'>
    <div className='container_certificate-content'>
    <img src={certificate1} alt='certificate1'  className='content-img' />

    </div>
    <div className='container_certificate-content'>
    <img src={certificate2} alt='certificate2' className='content-img' />

    </div>

    </div>
    
    </div>
  );
}